import { mergeAttributes, Node } from "@tiptap/core"
import { Plugin } from "@tiptap/pm/state"
import * as z from "zod"
import { CARD_COLORS } from "../../util/colors"
import { toTiptapAttributes } from "../../util/render-data"
import { CARD_VALUE_SCHEMA } from "../cards/card-content-extensions"

export const DateAnnotationNoteAttrsSchema = z.object({
  id: z.string().nullable().default(null),
  color: z.enum(CARD_COLORS).default("yellow"),
  dateString: z.string().default(""),
})

export type ExtensionDateAnnotationNoteAttrs = z.infer<typeof DateAnnotationNoteAttrsSchema>

export const DateAnnotationNoteTitleContentExtension = Node.create({
  name: "dateAnnotationNoteTitle",
  content: "text*",
  marks: "",

  renderHTML({ HTMLAttributes }) {
    return [
      "h2",
      mergeAttributes(HTMLAttributes, {
        "data-content-type": "dateAnnotationNoteTitle",
      }),
      0,
    ]
  },

  parseHTML() {
    return [
      {
        tag: 'h2[data-content-type="dateAnnotationNoteTitle"]',
      },
    ]
  },
})

export const DateAnnotationNoteContentExtension = Node.create({
  name: "dateAnnotationNote",
  group: "blockContainer addTarget",
  content: "dateAnnotationNoteTitle " + CARD_VALUE_SCHEMA,
  draggable: false,

  addAttributes: () => toTiptapAttributes(DateAnnotationNoteAttrsSchema),

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, { "data-content-type": "dateAnnotationNote" }),
      0,
    ]
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-content-type="dateAnnotationNote"]',
      },
    ]
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        filterTransaction(tr) {
          if (tr.before.firstChild?.type.name === "dateAnnotationNote") {
            if (tr.doc.childCount === 0 || tr.doc.firstChild?.type.name !== "dateAnnotationNote") {
              return false
            }
          }
          return true
        },
      }),
    ]
  },
})
